import { Link, useNavigate } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import DashboardEorder from "../../components/Dashboard/DashboardEorder";
import Dashboardfifth from "../../components/Dashboard/DashboardFifth";
import Dashboardfourth from "../../components/Dashboard/Dashboardfourth";
import EOrderDash from "../../components/Dashboard/EOrderDash";
import HomeDash from "../../components/Dashboard/HomeDash";
import DashboardAmount from "../../components/Dashboard/dashboardAmount";
import Dashboardthird from "../../components/Dashboard/dashboardthird";
import Navbar from "../../components/Navbar/Navbar";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading";
import ShimmerLoader, { DashboardShimmer } from "../../loading";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PurchaseDash from "../../components/Dashboard/PurchaseDash";
import { URLS } from "../../API/API endpoints";
import axios from "axios";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";
import IsAddProd from "../../assets/Dashboard/IsAddProd.svg";
import IsMachineCode from "../../assets/Dashboard/IsMachineCode.svg";
import IsCashierSetup from "../../assets/Dashboard/IsCashierSetup.svg";
import IsAddUser from "../../assets/Dashboard/IsAddUser.svg";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { LineChart } from "@mui/x-charts/LineChart";
import axiosInstance from "../../AxiosInstance";
import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import averageordervalue from "../../assets/Dashboard/averageordervalue.svg";
import posorders from "../../assets/Dashboard/posorders.svg";
import postotalsales from "../../assets/Dashboard/postotalsales.svg";
import totalcreditvalue from "../../assets/Dashboard/totalcreditvalue.svg";
import posProfit from "../../assets/Dashboard/pos_profit.svg";
import posProfitPercentage from "../../assets/Dashboard/pos_profit_percentage.svg";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { grey } from "@mui/material/colors";
import { useLocation } from "react-router-dom";

import dayjs from "dayjs";
import "dayjs/locale/ar"; // Arabic locale

const SalesReportTable = (data) => {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const formatEGP = (value) =>
    `EGP ${value.toLocaleString("en-EG", { minimumFractionDigits: 2 })}`;
  const TableHeaderCell = ({ children, align = "center", isFirst, isLast }) => {
    return (
      <th
        className={`px-0 py-0 ${
          align === "left"
            ? i18n.language == "ar"
              ? "text-right"
              : "text-left"
            : "text-center"
        }`}
      >
        <div
          className={`px-3 py-2 bg-white/80 backdrop-blur-md font-semibold text-gray-600
        ${isFirst ? "rounded-tl-2xl" : ""}
        ${isLast ? "rounded-tr-2xl" : ""}`}
        >
          {children}
        </div>
      </th>
    );
  };

  const handleRowClick = (row) => {
  navigate("/pos/orders", {
    state: {
      fromStore: {
        store_id: row.store_id,
        store_name: row.store_name,
        store_name_ar: row.store_name,
      },
    },
  });
};

  return (
    <div className="rounded-2xl bg-white border border-[#EDEEF1] p-4 overflow-hidden my-6">
      <h2 className="text-md font-semibold mb-4">{t("Store Sales Report")}</h2>

      <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto max-h-[70vh]">
          <table className="w-full border-collapse text-sm">
            {/* HEADER (same labels, better style) */}
            <thead className="sticky top-0 z-20 border-b border-gray-200">
              <tr>
                <TableHeaderCell isFirst align="left">
                  {t("Store Name")}
                </TableHeaderCell>
                <TableHeaderCell>{t("Total Sales")}</TableHeaderCell>
                <TableHeaderCell>{t("Orders")}</TableHeaderCell>
                <TableHeaderCell>{t("Avg. Order Value")}</TableHeaderCell>
                <TableHeaderCell>{t("Total Credit Value")}</TableHeaderCell>
                <TableHeaderCell>{t("Profit")}</TableHeaderCell>
                <TableHeaderCell>{t("Profit %")}</TableHeaderCell>
                 <TableHeaderCell >
                  {t("Total Refunded Amount (Orders)")}
                </TableHeaderCell>
                <TableHeaderCell isLast>{t("Total Discount (Products)")}</TableHeaderCell>
               
              </tr>
            </thead>

            {/* BODY */}
            <tbody className="divide-y divide-gray-100">
              {data?.data.map((row, index) => (
                <tr
                  key={index}
                    onClick={() => handleRowClick(row)}
  className="hover:bg-blue-50/40 transition-all duration-200 odd:bg-gray-50/50 cursor-pointer"
                >
                  <td className="px-4 py-4 font-medium text-gray-800">
                    {row.store_name}
                  </td>

                  <td className="px-4 py-4 text-center text-gray-700">
                    {formatEGP(row?.data?.total_sales)}
                  </td>

                  <td className="px-4 py-4 text-center text-gray-700">
                    {row?.data?.orders}
                  </td>

                  <td className="px-4 py-4 text-center text-gray-700">
                    {formatEGP(row?.data?.avg_order_value)}
                  </td>

                  <td className="px-4 py-4 text-center text-gray-700">
                    {formatEGP(row?.data?.total_credit_value)}
                  </td>

                  <td className="px-4 py-4 text-center font-semibold text-green-600">
                    {formatEGP(row?.data?.profit)}
                  </td>

                  <td className="px-4 py-4 text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        Number(row?.data?.profit_percentage) >= 15
                          ? "bg-green-100 text-green-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {row?.data?.profit_percentage !== null &&
                      row?.data?.profit_percentage !== undefined
                        ? `${Number(row.data.profit_percentage).toFixed(2)}%`
                        : "--"}
                    </span>
                  </td>

                 <td className="px-4 py-4 text-center text-gray-700">
                    {`${formatEGP(row?.data?.refund_order_amount)} (${row?.data?.refund_orders})`}
                  </td>

                   <td className="px-4 py-4 text-center text-gray-700">
                    {`${formatEGP(row?.data?.total_discount)} (${row?.data?.discounted_product_count})`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const PosDashboard = ({ start, end, refreshKey, selectedSession }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dashbaordData, setDashbaordData] = useState({});
  const [allStoreData, setAllStoreData] = useState({});
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );
  useEffect(() => {
    GetdashboardData();
    if (allStores) {
      GetAllStoresDetails();
    }
  }, [start, end, refreshKey, selectedSession, location.state, allStores]);

  const GetAllStoresDetails = async () => {
    try {
      const response = await axiosInstance.post(
        URLS.GET_ALL_STORES_DATA_DASHBOARD,
        {
          company_id,
          lang: i18n.language === "ar" ? "ar_001" : "en_US",
          start_date: start,
          end_date: end,
          session_id: selectedSession,
        }
      );
      if (response?.data?.result?.status_code === 200) {
        setAllStoreData(response?.data?.result?.data);
      } else {
        setAllStoreData({});
      }
    } catch (error) {
      console.log("Session fetch error:", error);
      setAllStoreData({});
    }
  };

  const GetdashboardData = async () => {
    let payload = {
      company_id: company_id,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
      ...(!selectedSession && { start_date: start }),
      ...(!selectedSession && { end_date: end }),
      session_id: selectedSession,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.POS_DASHBOARD, payload);
      // console.log("DATA===>", response?.data);

      if (response?.data?.result) {
        setDashbaordData(response?.data?.result);
      } else {
        setDashbaordData({});
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const topProducts = dashbaordData?.charts?.top_products || [];
  const dataset = topProducts?.slice(0, 10).map((item) => ({
    unit_sold: item.units_sold,
    product: i18n.language === "ar" ? item.product_name_ar : item.product_name,
  }));

  const values = [
    {
      img: postotalsales,
      heading: t("Total Sales"),
      productsleft: `EGP ${
        dashbaordData?.summary?.today?.sales
          ? dashbaordData?.summary?.today?.sales?.toFixed(2)
          : "0"
      }`,
      bgcolor: "#DBFBDA6B",
      textcolor: "#059003",
      // subHeading: `(${t("Last 7 days")})`,
    },
    {
      img: posorders,
      heading: t("Orders"),
      productsleft: `${dashbaordData?.summary?.today?.orders || "0"}`,
      bgcolor: "#2F80ED29",
      textcolor: "#2F80ED",
      // subHeading: `(${t("Today")})`,
      action: () => navigate("/pos/orders"),
    },
    {
      img: averageordervalue,
      heading: t("Average Order Value"),
      productsleft: `EGP ${
        dashbaordData?.summary?.average_order_value
          ? dashbaordData?.summary?.average_order_value?.toFixed(2)
          : "0"
      }`,
      bgcolor: "#FFE5CD85",
      textcolor: "#EB853C",
      // subHeading: `(${t("Last 7 days")})`,
    },
    {
      img: totalcreditvalue,
      heading: t("Total Credit Value"),
      productsleft: `EGP ${
        dashbaordData?.summary?.total_credit_value
          ? dashbaordData?.summary?.total_credit_value?.toFixed(2)
          : "0"
      }`,
      bgcolor: "#EB575729",
      textcolor: "#EB5757",
      action: () => navigate("/pos/credithistory"),
      isNonFiltered: true,
      //   wide: true,
    },
    {
      img: posProfit,
      heading: t("Profit"),
      productsleft: `EGP ${
        dashbaordData?.summary?.pos_profit
          ? dashbaordData?.summary?.pos_profit?.toFixed(2)
          : "0"
      }`,
      bgcolor: "#00BFA51F",
      textcolor: "#00BFA5",
      //   wide: true,
    },
    {
      img: posProfitPercentage,
      heading: t("Profit Percentage"),
      // productsleft: ` ${dashbaordData?.summary?.profit_percentage
      //   ? dashbaordData?.summary?.profit_percentage?.toFixed(2)
      //   : "0"
      //   } ${("%")}`,
      productsleft:
        dashbaordData?.summary?.profit_percentage !== undefined ? (
          <span dir="ltr">
            {dashbaordData.summary.profit_percentage.toFixed(2)}%
          </span>
        ) : (
          <span dir="ltr">0%</span>
        ),
      bgcolor: "#7E57C229",
      textcolor: "#7E57C2",
      //   wide: true,
    },
    {
      img: totalcreditvalue,
      heading: t("Total Refunded Amount (Orders)"),
      productsleft: `EGP ${
        -dashbaordData?.summary?.today?.refund_order_amount || "0"
      } (${
        dashbaordData?.summary?.today?.refund_order_count || "0"
      })`,
      bgcolor: "#EB575729",
      textcolor: "#EB5757",
       action: () => navigate("/pos/orders"),
      // action: () => navigate("/pos/credithistory"),
      //   wide: true,
    },
    {
      img: posorders,
      heading: t("Total Discount (Products)"),
      productsleft: `EGP ${
        dashbaordData?.summary?.discount_data?.total_discount || "0"
      } (${
        dashbaordData?.summary?.discount_data?.discounted_product_count || "0"
      })`,
      bgcolor: "#2F80ED29",
      textcolor: "#2F80ED",
      // subHeading: `(${t("Today")})`,
     
    },
    
  ];

  const chartSetting = {
    yAxis: [
      {
        label: t("Units Sold"),
        labelStyle: {
          fontFamily: "Cairo, sans-serif",
          fontWeight: 600, // optional
        },
      },
    ],
    margin: { left: 80, right: 70 }, // 👈 add space on the left'
    borderRadius: 7,
    series: [
      { dataKey: "unit_sold", label: t("Units Sold"), color: "#2F80ED" },
    ],
    height: 330,
    sx: {
      [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
        transform: "translateX(-30px)",
      },
    },
  };

  const salesData = dashbaordData?.charts?.daily_pos_sales || [];
  // Take last 14 entries
  const last14 = salesData.slice(-14);
  const xAxisData = last14.map((item) =>
    dayjs(item.order_date)
      .locale(i18n.language == "ar" ? "ar" : "en") // switch to Arabic
      .format("DD MMM")
  );
  const yAxisData = last14.map((item) => item.total_sales);

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <div className="custom-scrollbar flex-grow overflow-y-auto overflow-hidden">
          {loading ? (
            <div className=" mt-3 me-4">
              <DashboardShimmer />
            </div>
          ) : (
            <>
              <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                {Object.values(values).map((val, index) => (
                  <div
                    key={index}
                    className={`relative flex items-center rounded-xl px-2 py-4 shadow-sm transition-transform transform ${
                      val.action
                        ? "hover:scale-[1.02] hover:shadow-lg cursor-pointer"
                        : ""
                    }`}
                    style={{ backgroundColor: val.bgcolor }}
                    onClick={val.action}
                  >
                    <div className="flex items-center justify-between gap-3">
                      {val?.isNonFiltered && (
                        <div className="absolute top-1 right-1">
                          <FilterAltOffIcon
                            fontSize="small"
                            sx={{ color: grey[500] }}
                          />
                        </div>
                      )}

                      <div className="flex items-center gap-2">
                        <img src={val.img} alt="icon" className="w-10 h-10" />
                        <div className="flex flex-col">
                          <div className="flex flex-row items-center">
                            <p className="text-[13px] font-medium text-gray-700 truncate">
                              {val.heading}
                            </p>
                            <p className="text-[9px] font-medium text-[#111111B2] ps-1">
                              {val.subHeading}
                            </p>
                          </div>

                          <p
                            className="text-xl font-bold"
                            style={{ color: val.textcolor }}
                          >
                            {val.productsleft}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {allStores && allStoreData && allStoreData?.length > 0 && (
                <SalesReportTable data={allStoreData} />
              )}
              <div dir="ltr" className="mt-4 flex flex-col gap-4 md:flex-row">
                <div className="min-h-[380px] w-full rounded-2xl border border-[#EDEEF1] bg-white px-3 py-4 sm:px-5">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Daily Sales (14 Days)")}
                  </h3>
                  {yAxisData?.length > 0 ? (
                    <>
                      <div className="overflow-x-auto">
                        <div className="min-w-[620px]">
                          <LineChart
                            height={330}
                            xAxis={[
                              {
                                id: "days",
                                data: xAxisData,
                                scaleType: "point", // important when x values are strings
                              },
                            ]}
                            series={[
                              {
                                id: "Sales",
                                label: t("Daily Sales"),
                                data: yAxisData,
                                area: true,
                                color: "#1ABC9C",
                              },
                            ]}
                            margin={{ left: 80 }} // 👈 add space on the left
                            yAxis={[
                              {
                                label: t("Sales Value (EGP)"),
                                labelStyle: {
                                  fontFamily: "Cairo, sans-serif",
                                  fontWeight: 600, // optional
                                },
                              },
                            ]}
                            sx={{
                              [`& .${axisClasses.directionY} .${axisClasses.label}`]:
                                {
                                  transform: "translateX(-30px)",
                                },
                            }}
                            slotProps={{
                              legend: {
                                direction: "column", // row | column
                                position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                                padding: 0,
                                itemMarkWidth: 25, // size of color box
                                itemMarkHeight: 15,
                                labelStyle: {
                                  fontFamily: "Cairo, sans-serif",
                                  marginLeft: 5,
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#333",
                                },
                              },
                            }}
                          />
                        </div>
                      </div>
                      <p
                        style={{ fontWeight: 600 }}
                        className="ms-2 mt-2 text-sm font-medium text-[#111111] sm:ms-6 md:ms-64 md:-mt-4"
                      >
                        {t("Date")}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
                <div className="w-full rounded-2xl border border-[#EDEEF1] bg-white px-3 py-4 sm:px-5">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Top 10 Selling Products")}
                  </h3>
                  {dataset?.length > 0 ? (
                    <>
                      <div className="overflow-x-auto">
                        <div className="min-w-[620px]">
                          <BarChart
                            dataset={dataset}
                            xAxis={[
                              {
                                scaleType: "band",
                                dataKey: "product",
                                tickPlacement: "middle",
                                categoryGapRatio: 0.4,
                              },
                            ]}
                            {...chartSetting}
                            slotProps={{
                              legend: {
                                direction: "column", // row | column
                                position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                                padding: 0,
                                itemMarkWidth: 25, // size of color box
                                itemMarkHeight: 15,
                                labelStyle: {
                                  fontFamily: "Cairo, sans-serif",
                                  marginLeft: 5,
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#333",
                                },
                              },
                            }}
                          />
                        </div>
                      </div>
                      <p
                        style={{ fontWeight: 600 }}
                        className="ms-2 mt-2 text-sm font-medium text-[#111111] sm:ms-6 md:ms-64 md:-mt-4"
                      >
                        {t("products")}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PosDashboard;
